import React from "react";
import "./Title.css";

function Title() {
  return <div className="title-text">EO Unlocked</div>;
}

export default Title;
